import React from 'react';
import produce from 'immer';
import { DraggableBehavior } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/behaviors-list';
import { MetricEntryBehavior } from 'common/query-builder/query-entry-section/types';
import type { RowProps } from '../catalog';
export function UserBehaviorDefinition(props: RowProps) {
  const onSelect = (behavior: MetricEntryBehavior) => {
    props.updateEntry(produce(props.entry, draft => {
      draft.behavior = behavior;
    }));
  };
  return <DraggableBehavior {...props} metricIndex={props.index} parentMetricIndex={props.parentMetricIndex} behavior={props.entry.behavior} rowIcon='users' onSelect={onSelect} data-sentry-element="DraggableBehavior" data-sentry-component="UserBehaviorDefinition" data-sentry-source-file="behavior-definition.tsx" />;
}